import { currency } from 'functions';
import React, { useState } from 'react';

import { colorShade } from './functions';

const Plans = ({ checkout, plans, selectedPlan, setSelectedPlan }) => {
  const [status, setStatus] = useState(false);

  return (
    <>
      <section id='plans'>
        {plans.length >= 2 ? (
          <div className='card-head'>Escolha seu plano de assinatura</div>
        ) : (
          <div className='card-head'>
            Plano de assinatura selecionado abaixo
          </div>
        )}
        <div className='plans-list'>
          {plans.map((item, index) => {
            return (
              <div
                className={selectedPlan === item ? 'plan active' : 'plan'}
                key={index}
                onClick={() => {
                  setSelectedPlan(item);
                }}
              >
                <div className='header'>{item.label}</div>
                {item.subscription_fee && (
                  <div
                    className='content'
                    style={
                      selectedPlan === item
                        ? { background: colorShade(checkout.hex_color, 30) }
                        : null
                    }
                  >
                    <div className='list-item'>
                      <span className='price-sub'>
                        {currency(item.subscription_fee_price)}
                      </span>
                      <span className='description-sub'>adesão</span>
                    </div>
                  </div>
                )}
                <div
                  className={
                    item.subscription_fee
                      ? 'content-box-shadow mt-0'
                      : 'content mt-0'
                  }
                >
                  <div className='list-item'>
                    <span className='price'>{currency(item.price)}</span>
                    <span className='description'>{item.frequency}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default Plans;
